import React from "react";

import {DateRangePickerContextProvider} from "contexts/DateRangePickerContext";
import Dashboard from "views/marketplace/retailer/dashboard-new/Dashboard";

export default function Index() {
    return (
        <DateRangePickerContextProvider>
            <Dashboard />
        </DateRangePickerContextProvider>
    );
}
